import checkAuthenticated from "@/router/middlewares/checkAuthenticated";
import DECORATION_TYPES from '@/router/enums/DECORATION_TYPES';

export default [
  {
    path: '/timesheetBilling',
    name: 'TimesheetBillingView',
    component: () => import(/* webpackChunkName: "timesheetBilling" */ '../../src/modules/billing/TimesheetBillingView'),
    meta: {
      moduleId: 'timesheetBilling',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    beforeEnter: checkAuthenticated
  },
]
